/* eslint-disable react/jsx-child-element-spacing */
/* eslint-disable react/no-deprecated */
/* eslint-disable indent */
import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';

import LoginForm from './Form';
import OtpScreen from '../Otp';

import { whenUserLoggedIn } from '../../../AppUtil/AppUtil';

const APP_STRING = window.AppStrings;
const APPLICATION_EXCEPTION = window.ApplicationException;
const APP_LOGIN_CHALLENGES = window.LoginChallenges;

class index extends Component {
	// NOSONAR

	constructor(props) {
		super(props);
		this.state = {
			_isLogInBtnLoaderOn: false,
			_loginUser: null,
			_authUser: null,
			_isOtpScreenOpen: false,
			_resetLoginForm: false,
			_authError: '',
			_otpScreenMode: 'mobile'
		};
	}

	resetAuthError = () => {
		this.setState({
			_authError: ''
		});
	};

	redirectToOtpScreen = mode => {
		this.setState({
			_isOtpScreenOpen: true,
			_isLogInBtnLoaderOn: false,
			_otpScreenMode: mode
		});
	};

	setErrorMessage = message => {
		this.setState({
			_authError: message,
			_isLogInBtnLoaderOn: false,
			_resetLoginForm: true
		});
	};

	onUserDoesNotExist = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.sign_up'),
			text: this.props.t('sweetalert.user_doesnt_exist'),
			// icon: 'error',
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			confirmButtonText: this.props.t('buttons.sign_up'),
			onClose: this.props.openSignUpForm(),
			customClass: 'otp_message_success'
		});
	};

	signIn = async userDetail => {
		// NOSONAR
		this.setState({
			_isLogInBtnLoaderOn: true,
			_loginUser: userDetail
		});
		let user = null;
		try {
			user = await Auth.signIn(userDetail.username, userDetail.password);
		
			if (!user.challengeName) {
				await this.logedUserIn();
			} else if (
				user.challengeName === APP_LOGIN_CHALLENGES.SMS_MFA ||
				user.challengeName === APP_LOGIN_CHALLENGES.SOFTWARE_TOKEN_MFA
			) {
				this.setState({ _authUser: user });
				this.redirectToOtpScreen(APP_STRING.MOBILE);
			} else if (user.challengeName === APP_LOGIN_CHALLENGES.NEW_PASSWORD_REQUIRED) {
				await Auth.completeNewPassword(user, userDetail.password);
				await this.signIn(userDetail);
			} else if (user.challengeName === APP_LOGIN_CHALLENGES.MFA_SETUP) {
				await Auth.setupTOTP(user);
			} else {
				console.log(user);
			}
		} catch (err) {
			if (err.code === APPLICATION_EXCEPTION.USER_NOT_CONFIRMED_EXCEPTION) {
				this.redirectToOtpScreen(user);
			} else if (err.code === APPLICATION_EXCEPTION.NOT_AUTHORIZED_EXCEPTION) {
				if (err.message === APPLICATION_EXCEPTION.USER_DISABLED) {
					this.setErrorMessage(this.returnLink());
				} else {
					this.setErrorMessage(this.props.t('error_message.incorrect_username_or_password'));
				}
			} else if (err.code === APPLICATION_EXCEPTION.USER_NOT_FOUND_EXCEPTION) {
				this.onUserDoesNotExist();
			} else if (err.code === 'PasswordResetRequiredException') {
				this.setErrorMessage(err.message);
			} else {
				console.log(err);
			}
		}
	};

	returnLink = () => {
		return (
			<span style={{ marginTop: '5px' }}>
				{this.props.t('signin.user_is_disabled')}
				<a
					href="#void"
					onClick={e => {
						e.preventDefault();
					}}>
					{this.props.t('signin.suspend_lendami')}
				</a>
			</span>
		);
	};

	sendLoginRequest = async () => {
		await this.signIn(this.state._loginUser);
	};

	verifyLogin = async otp => {
		await Auth.confirmSignIn(this.state._authUser, otp);
		await this.logedUserIn();
	};

	verifyEmail = async otp => {
		await Auth.verifyCurrentUserAttributeSubmit(APP_STRING.EMAIL, otp);
		await this.logedUserIn();
	};

	logedUserIn = async () => {
		// await whenUserLoggedIn(this.props, '/app/user_logged_in', 'LOAN_LIST');
		//commented out due to error upon logging in, since also it's supposed to redirect directly to start_a_loan instead of the dashboard or formerly known as loan_list.
		await whenUserLoggedIn(this.props, '/app/user_logged_in', 'HOME');
	};

	sendEmailVerificationRequest = async () => {
		await Auth.verifyCurrentUserAttribute(APP_STRING.EMAIL);
	};

	render() {
		if (!this.state._isOtpScreenOpen) {
			return (
				<LoginForm
					authError={this.state._authError}
					isLogInBtnLoaderOn={this.state._isLogInBtnLoaderOn}
					onSubmit={this.signIn}
					openForgotPasswordScreen={this.props.openForgotPasswordScreen}
					openSignUpForm={this.props.openSignUpForm}
					resetAuthError={this.resetAuthError}
					resetLoginForm={this.state._resetLoginForm}
					user={this.props.user}
					footer={this.props.footer}
				/>
			);
		} else {
			return (
				<OtpScreen
					mode={this.state._otpScreenMode}
					resendOtp={
						this.state._otpScreenMode === APP_STRING.EMAIL
							? this.sendEmailVerificationRequest
							: this.sendLoginRequest
					}
					verifyOtp={this.state._otpScreenMode === APP_STRING.EMAIL ? this.verifyEmail : this.verifyLogin}
				/>
			);
		}
	}
}

export default withTranslation()(index);
